import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useProgram } from 'app/hooks/useProgram';

const MicrositeKonfirmasiSuksesRegis = () => {
	const navigate = useNavigate();

	const program = useProgram();

	React.useEffect(() => {
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	const backHandler = () => {
		navigate(-1);
	};

	return (
		<Div className='custompage'>
			<ContentWrapper>
				<Div className='content-padding'>
					{/* <Div className='back-icon'>
						<KeyboardBackspaceIcon onClick={backHandler}/>
						<Div className='flex-justify-start' sx={{marginLeft: '28px'}}>
							
						</Div>
					</Div> */}
					<Div className='mt-2'>
						<Typography sx={{ mt: 2 }} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Selamat! Anda telah terdaftar ke dalam {program}</Typography>
						<Div className='dis-flex-center' sx={{ mt: 2 }}>
							<img className='illust-state' src={`${process.env.REACT_APP_IMAGES_PATH}/AddleadsSukses.svg`} width={265} height={265} />
						</Div>

						<Div className='flex-justify-center' sx={{ mt: 2 }}>
							<ButtonStyled
								btnText={"Ubah Password"}
								sx={{ maxWidth: '451px' }}
							/>
						</Div>
					</Div>
				</Div>

			</ContentWrapper>
		</Div>

	);
};

export default MicrositeKonfirmasiSuksesRegis;